import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCustodePoints, firstNameFromUser } from "../../utils/passportPoints";

/**
 * Widget header: «Ciao Paolo! 🏅 50 pt» quando la sessione cittadino è attiva.
 */
export default function CustodeProfileWidget({ user, compact = false }) {
  const [points, setPoints] = useState(null);
  const nome = firstNameFromUser(user);

  useEffect(() => {
    if (!user) {
      setPoints(null);
      return undefined;
    }
    let cancelled = false;
    fetchCustodePoints().then((n) => {
      if (!cancelled) setPoints(n);
    });
    const bump = () => {
      fetchCustodePoints().then((n) => {
        if (!cancelled) setPoints(n);
      });
    };
    window.addEventListener("passaporto:update", bump);
    window.addEventListener("6amico_timbro_aggiunto", bump);
    return () => {
      cancelled = true;
      window.removeEventListener("passaporto:update", bump);
      window.removeEventListener("6amico_timbro_aggiunto", bump);
    };
  }, [user]);

  if (!user) return null;

  const ptsLabel = points == null ? "…" : `${points} pt`;

  return (
    <Link
      to="/profilo"
      className={
        compact
          ? "min-h-[48px] flex items-center gap-2 px-3 rounded-lg text-base font-sans font-semibold text-stone-900 hover:bg-[#f7efe6]"
          : "min-h-[44px] inline-flex items-center gap-2 px-3.5 rounded-full border border-[#ecd9c2] bg-[#f7efe6] text-sm font-sans font-semibold text-stone-900 hover:border-[#162d4a] transition-colors max-w-[220px]"
      }
      data-testid="custode-profile-widget"
      title="Il tuo profilo Custode"
    >
      {user.picture ? (
        <img
          src={user.picture}
          alt=""
          className="w-7 h-7 rounded-full object-cover shrink-0"
          width={28}
          height={28}
        />
      ) : (
        <span
          className="w-7 h-7 rounded-full bg-[#162d4a] text-white text-xs font-bold inline-flex items-center justify-center shrink-0"
          aria-hidden
        >
          {(nome || "C").charAt(0).toUpperCase()}
        </span>
      )}
      <span className="truncate">
        Ciao {nome}!{" "}
        <span className="whitespace-nowrap" aria-label={`${ptsLabel} Passaporto`}>
          🏅 {ptsLabel}
        </span>
      </span>
    </Link>
  );
}
